module.exports = __webpack_public_path__ + "img/item2sssss.55d01107.jpg";